import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { TextField, Button, Box, Typography } from "@mui/material";
import axios from "axios";
import { CONFIG } from "./config";

function RestaurarContrasena() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [cognitoUsername, setCognitoUsername] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSendCode = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!email.trim()) newErrors.email = true;
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setIsLoading(true);
    try {
      const res = await axios.post(
        CONFIG.BACKEND_URL + "/backend/forgot-password",
        { email: email.trim() }
      );
      if (res.data?.code === 200) {
        if (res.data.cognitoUsername) {
          setCognitoUsername(res.data.cognitoUsername);
        } else {
          setCognitoUsername("");
        }
        alert(res.data.message);
        setStep(2);
      }
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.message ||
        "No se pudo enviar el código.";
      alert("Error: " + msg);
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirm = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!code.trim()) newErrors.code = true;
    if (!newPassword) newErrors.newPassword = true;
    if (newPassword !== confirmPassword) newErrors.confirmPassword = true;
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setIsLoading(true);
    try {
      const res = await axios.post(
        CONFIG.BACKEND_URL + "/backend/confirm-forgot-password",
        {
          email: email.trim(),
          code: code.trim(),
          newPassword,
          ...(cognitoUsername ? { cognitoUsername } : {}),
        }
      );
      if (res.data?.code === 200) {
        alert(res.data.message);
        navigate("/login");
      }
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.message ||
        "No se pudo restablecer la contraseña.";
      alert("Error: " + msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="d-flex animation-container bg">
      <div className="m-auto box-form">
        <Typography variant="h4" gutterBottom>
          Restaurar contraseña
        </Typography>

        {step === 1 && (
          <Box
            component="form"
            onSubmit={handleSendCode}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 2,
              width: "100%",
              maxWidth: "400px",
            }}
          >
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Escribe el correo de tu cuenta. Si está registrado, te enviaremos
              un código para elegir una nueva contraseña. No olvides revisar el spam de tu correo
            </Typography>
            <TextField
              label="Correo electrónico"
              variant="outlined"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={!!errors.email}
              helperText={errors.email ? "El correo es requerido" : ""}
              sx={{ mb: 2, width: "100%" }}
              disabled={isLoading}
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={isLoading}
            >
              {isLoading ? "Enviando..." : "Enviar código"}
            </Button>
          </Box>
        )}

        {step === 2 && (
          <Box
            component="form"
            onSubmit={handleConfirm}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 2,
              width: "100%",
              maxWidth: "400px",
            }}
          >
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Revisa tu correo, introduce el código y tu nueva contraseña.
            </Typography>
            <TextField
              label="Correo electrónico"
              variant="outlined"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ mb: 2, width: "100%" }}
              disabled={isLoading}
            />
            <TextField
              label="Código de verificación"
              variant="outlined"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              error={!!errors.code}
              helperText={errors.code ? "El código es requerido" : ""}
              sx={{ mb: 2, width: "100%" }}
              disabled={isLoading}
            />
            <TextField
              label="Nueva contraseña"
              variant="outlined"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              error={!!errors.newPassword}
              helperText={
                errors.newPassword ? "La nueva contraseña es requerida" : ""
              }
              sx={{ mb: 2, width: "100%" }}
              disabled={isLoading}
            />
            <TextField
              label="Confirmar nueva contraseña"
              variant="outlined"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              error={!!errors.confirmPassword}
              helperText={
                errors.confirmPassword
                  ? "Las contraseñas no coinciden"
                  : ""
              }
              sx={{ mb: 2, width: "100%" }}
              disabled={isLoading}
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={isLoading}
            >
              {isLoading ? "Guardando..." : "Restablecer contraseña"}
            </Button>
            <Button
              type="button"
              variant="text"
              sx={{ mt: 1 }}
              onClick={() => {
                setCognitoUsername("");
                setStep(1);
              }}
              disabled={isLoading}
            >
              Volver a enviar código
            </Button>
          </Box>
        )}

        <Typography sx={{ mt: 2, textAlign: "center" }}>
          <Link to="/login">Volver al inicio de sesión</Link>
        </Typography>
      </div>
    </div>
  );
}

export default RestaurarContrasena;
